module.exports = __webpack_public_path__ + "static/img/Q2_Uyghurs_mobile.jpg";